import {Button} from "@/primitives/Button";

export interface CalendarSyncPanelProps {
	googleSyncUrl: string | null;
	microsoftSyncUrl: string | null;
}

/*
 * Entry points into the workspace calendar integrations, one per provider the administrator enabled
 * (TIMR-12708, TIMR-13062). Every user connects their own account, so the entry point stays the same whether or not
 * this user is already connected.
 */
export function CalendarSyncPanel({googleSyncUrl, microsoftSyncUrl}: CalendarSyncPanelProps) {
	// The Microsoft integration is marketed under the name of its calendar, so it shows up as "Outlook Calendar".
	const providers = [
		{name: messages["integrations.google.name"], logo: "/timr/images/integrations/google.svg", url: googleSyncUrl},
		{name: messages["integrations.microsoft.name"], logo: "/timr/images/integrations/microsoft.svg", url: microsoftSyncUrl}
	].filter((provider) => provider.url != null);

	return (
		<div className="panel panel-flat">
			<div className="panel-heading">
				<h5 className="panel-title">{messages["user.settings.calsync.title"]}</h5>
			</div>
			<div className="panel-body">
				{providers.map((provider, index) => (
					<div key={provider.name} className={`display-flex justify-content-space-between${index > 0 ? " mt-20" : ""}`}>
						<div className="display-flex flex-valign-middle">
							<img src={provider.logo} alt={provider.name} height={36}/>
							<span className="ml-10">{provider.name}</span>
						</div>
						<Button render={<a href={provider.url} target="_blank" rel="noopener noreferrer"/>}>
							{messages["user.settings.calsync.sync"]}
						</Button>
					</div>
				))}
			</div>
		</div>
	);
}
